import { getImageDimensions } from '@sanity/asset-utils';
import imageUrlBuilder from '@sanity/image-url';
import type { SanityImageProps } from '@veranda/shared/sanity/utils/fragments/image-fragment';
import Image from 'next/image';
import type { CSSProperties } from 'react';
import { cn } from '../../../lib/utils';
import { client } from '../client';

export interface SanityImage {
  image: SanityImageProps;
  className?: string;
  sizes?: string;
  fill?: boolean;
  width?: number;
  height?: number;
  priority?: boolean;
  noLQIP?: boolean;
  quality?: number;
  style?: CSSProperties;
}

const builder = imageUrlBuilder(client);

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
function urlForImage(source: any) {
  return builder.image(source).auto('format').fit('max').format('webp');
}

export const SanityImage = ({
  image,
  className,
  sizes,
  fill,
  priority,
  width,
  height,
  noLQIP,
  quality,
  style,
}: SanityImage) => {
  if (!image || !image.asset) {
    return null;
  }

  const altText = image.asset?.altText || '';
  const dimensions = getImageDimensions(image.asset);

  const widthProp = width ?? dimensions.width;
  const heightProp = height ?? dimensions.height;

  return (
    <>
      {image?.asset && (
        <Image
          fetchPriority={priority ? 'high' : 'auto'}
          priority={priority}
          quality={quality}
          src={urlForImage(image).url()}
          alt={altText}
          width={fill ? undefined : widthProp}
          height={fill ? undefined : heightProp}
          placeholder={noLQIP ? undefined : 'blur'}
          blurDataURL={noLQIP ? undefined : (image.asset?.metadata?.lqip ?? '')}
          className={cn('', fill && 'object-cover', className)}
          sizes={
            sizes ?? '(max-width: 768px) 100vw,(max-width: 1200px) 50vw,40vw'
          }
          fill={fill}
          style={style}
        />
      )}
    </>
  );
};
